/**
 * zeluslugi.ru
 * Навигация главная
 * @author      delphinpro <delphinpro@gmail.com>
 * @license     licensed under the MIT license
 */

(function ($) {
    $('.hamburger').on('click', function () {
        $(document.body).toggleClass('_f_is-visible-menu');
    });

    $(window).on('scroll', function () {
        $(document.body).toggleClass('isScrolled', $(window).scrollTop() > 300);
    });

    $('.nav > ul > li  a').on('click', function (e) {
        console.log(this);
        if (window.innerWidth < 992) {
            var $dropdown = $(this).next('div');
            if ($dropdown.length) {
                var $item = $(this).parent();
                if (!$item.hasClass('openChildren')) {
                    e.preventDefault();
                    $item.siblings().removeClass('openChildren');
                    $dropdown.slideDown(function () {
                        $item.addClass('openChildren');
                        $dropdown.removeAttr('style');
                    });
                }
            }
        }
    });

    let timeout = 300;
    $('.nav li')
        .on('mouseenter', function () {
            if (window.innerWidth >= 992) {
                let $item = $(this);
                clearTimeout($item.data('timer'));
                $item.addClass('hover');
                if ($item.children('div').length) {
                    $item.siblings().removeClass('hover');
                }
            }
        })
        .on('mouseleave', function () {
            if (window.innerWidth >= 992) {
                let $item = $(this);
                let timer = setTimeout(() => $item.removeClass('hover'), timeout);
                $item.data('timer', timer);
            }
        });
})(jQuery);
